import Swiper, { Navigation, Autoplay, EffectFade } from 'swiper';

export function slider() {
  const gallerySlide = new Swiper('.js-gallery', {
    modules: [Navigation, Autoplay],
    navigation: {
      nextEl: '.js-galleryNext',
      prevEl: '.js-galleryPrev',
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    slidesPerView: 1.5,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    breakpoints: {
      768: {
        spaceBetween: 40,
        slidesPerView: 2.5,
      },
      1000: {
        spaceBetween: 40,
        slidesPerView: 4.5,
      },
    },
  });
}

export function heroSlider() {
  const heroSlider = new Swiper('.js-heroSlider', {
    modules: [Autoplay, EffectFade],
    effect: 'fade',
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    loop: true,
  });
}
